import { COLORS, TYPE } from './tokens'

// Small-caps letterspaced label used above each section head and inside
// finding metadata footers. Renders a hairline divider underneath.
// Optional `variant` prop:
//   'default'  — muted color, hairline underneath
//   'accent'   — teal color, no underline
//   'severity' — used for HIGH SEVERITY, REGRESSED, etc.
export default function SectionLabel({ children, variant = 'default', color, style = {} }) {
  const base = { ...TYPE.smallCaps, color: color || COLORS.mutedText, ...style }
  if (variant === 'accent') return <span style={{ ...base, color: COLORS.accent }}>{children}</span>
  if (variant === 'severity') return <span style={{ ...base, color: COLORS.bodyText }}>{children}</span>
  return (
    <div style={{ borderBottom: `1px solid ${COLORS.hairline}`, paddingBottom: '10px', marginBottom: '16px' }}>
      <span style={base}>{children}</span>
    </div>
  )
}
